import { MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import useUserHook from 'hooks/useUserHook';

import { IContract, IProject, useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList-2.query';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ModalManger } from 'components/common/ProgramLibraryDropdownMenu/components/ModalManger/ModalManager';
import classes from 'components/common/ProgramLibraryDropdownMenu/dropdownMenu.module.scss';
import { findeNodeByUUID } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';
import { Button, CustomizedDropdownMenu, CustomizedTooltip } from 'components/common/index';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

export const DropdownMenu = ({
    callback,
}: {
    callback?: (project: IProject | null, contract: IContract | null) => void;
}) => {
    const { project, contract, update } = useProjectTreeStore();
    const { ability } = useUserHook();

    const isAdmin = ability.can('all', 'Admin');

    const { data } = useQueryGetGeneralHierarchyList();
    const handleAddSubProject = () => {
        if (data) {
            const parent = data && project ? findeNodeByUUID(data, project.uuid) : null;
            update({ parentNode: parent });
        }
        update({ modalType: 'subProgram' });
    };

    return (
        <>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Manage library`}
                        triggerElement={
                            <Button
                                data-testid={'manage-library'}
                                endIcon={
                                    <Icon
                                        name={'header-arrow-down'}
                                        size={'1.5rem'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                startIcon={
                                    <MuiIcon
                                        icon={'folder'}
                                        type={'outlined'}
                                        fontSize={'1.5rem'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                variant={'secondary'}
                            >
                                Manage library
                            </Button>
                        }
                    />
                }
                menuStyles={{
                    maxHeight: 'initial',
                }}
            >
                <MenuItem onClick={() => update({ modalType: 'project' })}>Add Project</MenuItem>
                <MenuItem onClick={handleAddSubProject}>Add Sub Program</MenuItem>

                {contract && (
                    <MenuItem onClick={() => update({ modalType: 'RENAME_SUB_PROGRAM' })}>Rename Sub-Program</MenuItem>
                )}
                <MenuItem onClick={() => update({ modalType: 'RENAME_PROJECT' })}>Rename Project</MenuItem>
                {contract && (
                    <MenuItem onClick={() => update({ modalType: 'DELETE_SUB_PROGRAM' })}>Delete Sub-Program</MenuItem>
                )}
                <MenuItem onClick={() => update({ modalType: 'DELETE_PROJECT' })}>Delete Project</MenuItem>
                {contract && isAdmin && (
                    <MenuItem onClick={() => update({ modalType: 'REFRESH_SUB_PROGRAM' })}>
                        Refresh Sub-Program
                    </MenuItem>
                )}
                {isAdmin && (
                    <MenuItem onClick={() => update({ modalType: 'REFRESH_PROJECT' })}>Refresh Project</MenuItem>
                )}
                {contract && (
                    <MenuItem>
                        <Link
                            className={classes.programLibraryMenuLink}
                            to={AppRoutes.buildPath(
                                AppRoutes.DASHBOARD_PLANNING_PATH,
                                executionConfig.programLibrary.link,
                                executionConfig.subProgramPreferences.link,
                            )}
                        >
                            Sub-Program Preferences
                        </Link>
                    </MenuItem>
                )}
                <MenuItem>
                    <Link
                        className={classes.programLibraryMenuLink}
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PLANNING_PATH,
                            executionConfig.programLibrary.link,
                            executionConfig.projectPreferences.link,
                        )}
                    >
                        Project Preferences
                    </Link>
                </MenuItem>
            </CustomizedDropdownMenu>

            <ModalManger callback={callback} />
        </>
    );
};
